module.exports = __webpack_public_path__ + "h5/img/03@2x.6ffe0aa2.png";